<template>
  <div class="l_homepage">
    <label for="foryou" class="foryou" v-if="this.isExistForYou">
      <input type="checkbox" id="foryou" v-model="checkForYou" />&nbsp;
      <span>「あなただけ」のお知らせのみ表示する</span>
    </label>
    <div v-if="this.currentNewsList1">
      <!-- 重要情報 -->
      <important-information
        v-for="(item, index) in this.currentNewsList1"
        :key="index"
        :id="item.id"
        :title="item.caption"
        :url="item.url"
        :isImportant="item.kind"
        @click="() => tapAction(item.id, item.url, item.caption, infoImportant)"
      />
      <!-- News情報 -->
      <div class="l_contents">
        <news-panel
          v-for="(item, index) in this.currentNewsList1"
          :key="index"
          :url="item.url"
          :image="item.thumb_url"
          :title="item.caption"
          :date="item.date"
          :category="item.category_id"
          :isImportant="item.kind"
          :youtubeId="item.youtube_id"
          @click="() => tapAction(item.id, item.url, item.caption, infoNews)"
        />
      </div>
    </div>
    <div
      class="menu_title"
      v-if="this.menuList.length >= 1 && this.checkForYou === false"
    >
      <span>ピックアップメニュー</span>
    </div>
    <div
      class="card-group"
      v-if="this.menuList.length >= 1 && this.checkForYou === false"
    >
      <div
        class="card"
        @click="tapActionMenu(item.id, item.url, item.caption)"
        v-for="item in this.menuList"
        :key="item"
      >
        <div class="card__imgframe">
          <img class="c_img" :src="item.thumb_url" />
        </div>
        <div class="card__textbox">
          <div class="card__titletext">
            {{ item.caption }}
          </div>
          <div class="card__overviewtext">
            <div class="en">
              <span>￥</span>
            </div>
            <div class="price">
              <!-- 2024.09.02 : 管理画面上で税抜価格に税込価格を入れるように変更のための対応 https://quadcojp.atlassian.net/browse/FRI-288 -->
              <span>{{ pickupMenuPriceForDisplay(item.menu_price) }}</span>
            </div>
            <div class="price_all">
              <span>（税込）</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.currentNewsList2">
      <!-- 重要情報 -->
      <important-information
        v-for="(item, index) in this.currentNewsList2"
        :key="index"
        :id="item.id"
        :title="item.caption"
        :url="item.url"
        :isImportant="item.kind"
        @click="() => tapAction(item.id, item.url, item.caption, infoImportant)"
      />
      <!-- News情報 -->
      <div class="l_contents">
        <news-panel
          v-for="(item, index) in this.currentNewsList2"
          :key="index"
          :url="item.url"
          :image="item.thumb_url"
          :title="item.caption"
          :date="item.date"
          :category="item.category_id"
          :isImportant="item.kind"
          :youtubeId="item.youtube_id"
          @click="() => tapAction(item.id, item.url, item.caption, infoNews)"
        />
      </div>
    </div>


    <!-- Popup背景  -->
    <div
      class="l_popup__cover animation_background"
      v-if="this.popups.length > 0"
    ></div>

    <!-- Popupパネル -->
    <home-popup
      v-for="(item, index) in this.popups"
      :key="`popup_${index}_${item.id}`"
      :id="item.id"
      :title="item.caption"
      :image="item.thumb_url"
      :isPopup="item.is_popup"
      @close="() => tapClose(item.id, item.caption)"
      @navigate="
        () => tapAction(item.id, item.url, item.caption, infoPopupDetail)
      "
    />
    <!-- エラーパネル -->
    <template v-if="this.isError">
      <error-popup
        :title="this.errorTitle"
        :message="this.errorMessage"
        :label="'もう一度試す'"
        @submit="() => tapRetryFetch()"
        @close="() => tapErrorClose()"
      />
    </template>
    <VersionCheck
      :show="verAlert"
      :on-close="closeAlert"
      :msg="versionErrorMsg"
    />
    <!-- 紹介成功 -->
    <template v-if="isInvitationSuccess">
      <AlertInvitationSuccess
        :point="numStamps"
        :inviterPoint="inviterNumStamps"
        :inviterExpireDays="inviterExpireDays"
        @close="() => (this.isInvitationSuccess = false)"
      />
    </template>
    <!-- 紹介失敗 -->
    <template v-if="isInvitationFailure">
      <AlertInvitationGetFailure
        :inviteeExpireDays="inviteeExpireDays"
        @close="() => (this.isInvitationFailure = false)"
      />
    </template>
  </div>
</template>

<script>
import NewsTab from './NewsTab.vue'
import ImportantInformation from '@/components/Home/ImportantInformation.vue'
import NewsPanel from '@/components/NewsPanel.vue'
import HomePopup from '@/components/Modal/HomePopup.vue'
import ErrorPopup from '@/components/Modal/ErrorPopup.vue'
import DateFormatter from '../../utils/DateFormatter.js'
import { FactoryTrack, ContentsType } from '../../constant/firebase'
import { mapActions, mapGetters } from 'vuex'
import APIClient, { ErrorCode, ErrorMessage } from '@/api/APIClient'
import VersionCheck from '../FAQWalkVersionCheck'
import AlertInvitationSuccess from '@/components/Modal/AlertInvitationSuccess'
import AlertInvitationGetFailure from '@/components/Modal/AlertInvitationGetFailure'

export default {
  name: 'Home',
  components: {
    AlertInvitationGetFailure,
    AlertInvitationSuccess,
    NewsTab,
    ImportantInformation,
    NewsPanel,
    HomePopup,
    ErrorPopup,
    VersionCheck
  },
  data: function() {
    return {
      idQueryString: 'id',
      notificationKey: 'notification',
      condition: '', // URLにidがついていれば、ここに入ります。
      isError: false,
      errorMessage: '',
      errorTitle: '',
      debugToken: '',
      infoNews: ContentsType.InfoNews,
      infoImportant: ContentsType.InfoImportant,
      infoPopupDetail: ContentsType.InfoPopupDetail,
      isLoaded: false,
      isAndroid: false,
      currentNewsList1: [],
      currentNewsList2: [],
      userType: '0',
      versionNo: '0',
      isExistForYou: false,
      checkForYou: false,
      versionAlert: false,
      errorMsg: '',
      verAlert: 0,
      versionErrorMsg: '',
      isInvitationSuccess: false,
      isInvitationFailure: false,
      numStamps: 0,
      inviterNumStamps: 0,
      inviterExpireDays: 0,
      inviteeExpireDays: 0
    }
  },
  computed: {
    ...mapGetters({
      menuList: 'Home/menuList',
      newsList1: 'Home/newsList1',
      newsList2: 'Home/newsList2',
      popups: 'Home/popups',
      lastUpdated: 'Home/lastUpdated',
      isBadge: 'Home/isBadge'
    }),
    isExistPremium: function() {
      return this.userType === '1' || this.userType === '2'
    },
  },
  watch: {
    $route(to, from) {
      console.log(to, from)
      if (!this.isLoaded) return
      this.__checkQuery()
      this.__checkAutoNavigate1()
    },
    // popup表示している間はスクロール固定する、App.vueにisFixedが設定される
    popups: function(values) {
      const isFixed = values.length > 0
      this.action_ToggleModal(isFixed)
    },
    // Badgeつけるかどうかはここで決める
    lastUpdated: function(value) {
      this.actionUnreadChanged(this.isBadge)
    },
    newsList1: function(val) {
      this.isExistForYou = val.some(item => {
        return item.use_user_id === '1' && item.target_user_type === '0'
      })
    },
    newsList2: function(val) {
      if (this.isExistForYou) return
      this.isExistForYou = val.some(item => {
        return item.use_user_id === '1' && item.target_user_type === '0'
      })
    },
    checkForYou: function(checked) {
      this.currentNewsList1 = this.newsList1.filter(data => {
        return (
          data.target_user_type === '0' &&
          (checked ? data.use_user_id === '1' : true)
        )
      })
      console.log('current', this.currentNewsList1)
      this.currentNewsList2 = this.newsList2.filter(data => {
        return (
          data.target_user_type === '0' &&
          (checked ? data.use_user_id === '1' : true)
        )
      })
      console.log('current', this.currentNewsList2)
    }
  },
  created: function() {
    this.__checkAndroid()
    this.__checkQuery()
    this.requestUserInfo()
  },
  mounted: function() {
    // 必ずページトップから始める
    setTimeout(() => {
      window.scrollTo(0, 1)
    }, 500)
  },
  beforeDestroy: function() {
    // ページ繊維でバッジ解除
    this.actionUnreadChanged('0')
  },
  methods: {
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Modal', ['action_ToggleModal']),
    ...mapActions('Native', [
      'actionRequestToken',
      'actionUnreadChanged',
      'actionCallNewsDetail',
      'actionNavigateTo',
      'actionVer5_2',
      'actionOpenDelivery',
      'actionOpenTakeOut',
      'actionOpenNetOrder',
      'actionRequestExternalLink',
      'actionHideHelp',
      'actionVer6_0',
      'actionRequestInvitationUUID',
      'actionRemoveInvitationUUID',
      'actionVer6_1'
    ]),
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Home', [
      'action_FetchInfo',
      'action_SelectDetailNews',
      'action_DeletePopup'
    ]),
    async linkTakeOut() {
      // Firebase Event track
      try {
        this.trackEvent(FactoryTrack.createInfoTakeOut())
      } catch (e) {
        console.log(e)
      }
      this.verAlert = await this.actionVer6_0()
      this.versionErrorMsg =
        'このボタンはアプリバージョン6.0.0以上対応です。<br />最新版のアプリにアップデートしてください。'
      if (this.verAlert === 0) {
        this.actionOpenTakeOut()
      }
      return false
    },
    async linkNetOrder() {
      // Firebase Event track
      try {
        this.trackEvent(FactoryTrack.createInfoNetOrder())
      } catch (e) {
        console.log(e)
      }
      this.verAlert = await this.actionVer6_0()
      this.versionErrorMsg =
        'このボタンはアプリバージョン6.0.0以上対応です。<br />最新版のアプリにアップデートしてください。'
      if (this.verAlert === 0) {
        this.actionOpenNetOrder()
      }
      return false
    },
    async linkDelivery() {
      // Firebase Event track
      try {
        this.trackEvent(FactoryTrack.createInfoDelivery())
      } catch (e) {
        console.log(e)
      }
      this.verAlert = await this.actionVer6_0()
      this.versionErrorMsg =
        'このボタンはアプリバージョン6.0.0以上対応です。<br />最新版のアプリにアップデートしてください。'
      if (this.verAlert === 0) {
        this.actionOpenDelivery()
      }
      return false
    },
    async linkNearbyShops() {
      // Firebase Event track
      try {
        this.trackEvent(FactoryTrack.createInfoNearbyShops())
      } catch (e) {
        console.log(e)
      }
      this.verAlert = await this.actionVer6_0()
      this.versionErrorMsg =
        'このボタンはアプリバージョン6.0.0以上対応です。<br />最新版のアプリにアップデートしてください。'
      if (this.verAlert === 0) {
        this.actionRequestExternalLink('https://www.joyfull.co.jp/sales/')
      }
      return false
    },
    async fbPageLink() {
      if (this.versionNo !== '0') {
        const deviceUA = window.navigator.userAgent.toLowerCase()
        const is_iPhone =
          deviceUA.indexOf('iphone') != -1 && deviceUA.indexOf('ipod') == -1 // iPhone (ここでは iPod touch を除外)
        const is_iPad =
          deviceUA.indexOf('ipad') != -1 ||
          (deviceUA.indexOf('macintosh') > -1 && 'ontouchend' in document) // iPad (旧 iOS, 新 iPad OS とも
        const is_Android = deviceUA.indexOf('android') != -1 // Android
        var fbPageUrl = ''
        if (is_iPhone || is_iPad) {
          // iPhone, iPad
          //fbPageUrl = 'fb://page?id=106138818710214'
          fbPageUrl = 'fb://page?id=0000'
        } else if (is_Android) {
          // Android
          //fbPageUrl = 'fb://page/106138818710214'
          fbPageUrl = 'fb://page/0000'
        }
        location.href = fbPageUrl
      } else {
        this.actionRequestExternalLink('https://www.facebook.com/joyfull.jp')
      }
      return false
    },
    openBrowser(url) {
      this.actionRequestExternalLink(url)
    },
    tapActionMenu(id, url, caption) {
      // Firebase Event track
      try {
        this.trackEvent(FactoryTrack.createInfoMenu(id, caption))
      } catch (e) {
        console.log(e)
      }
      this.actionRequestExternalLink(url)
    },
    tapAction(id, url, caption, type) {
      // Firebase Event track
      try {
        this.trackEvent(FactoryTrack.createInfoNews(id, caption, type))
      } catch (e) {
        console.log(e)
      }

      if (url !== '') {
        // external link
        this.navigateToRedirectDetail(id, url)
      } else {
        // internal link
        this.navigateToDetail(id)
      }
    },
    // URLがあれば、外部ページを詳細ページとして表示
    async navigateToRedirectDetail(id, url) {
      this.actionToggleLoading(true)
      this.actionHideHelp()
      window.scrollTo(0, 0)
      this.updateLocalStorage(id)
      this.action_SelectDetailNews(id)
      setTimeout(() => {
        this.actionToggleLoading(false)
      }, 500)
      const isInvalidVersion = await this.actionVer5_2()
      console.log('isInvalidVersion', isInvalidVersion)
      console.log(url)
      console.log(process.env.VUE_APP_BUYC_ENDPOINT)
      if (
        isInvalidVersion !== 0 &&
        url.startsWith(process.env.VUE_APP_BUYC_ENDPOINT)
      ) {
        console.log('show alert')
        this.versionAlert = isInvalidVersion
        this.errorMsg =
          'キャンペーンへの参加には、アプリバージョン5.2.0以上が必要です。<br />最新版のアプリにアップデートしてください。'
        this.actionToggleLoading(false)
        return
      }
      location.href = url
    },
    //  詳細ページへの遷移
    navigateToDetail(id) {
      try {
        this.updateLocalStorage(id)
        this.action_SelectDetailNews(id)
        this.$router.push({ name: 'HomeDetail' })
        // this.$router.push({ path: `/home/${id}` })
        this.actionHideHelp()
      } catch (e) {
        console.log(e)
      }
    },
    // クローズボタンを
    tapClose(id, caption) {
      this.trackEvent(FactoryTrack.createInfoPopupClose(id, caption))
      this.updateLocalStorage(id)
      this.action_DeletePopup(id)
    },
    // ローカルストレージデータの更新
    updateLocalStorage(id) {
      const key = 'news_' + id
      if (window.localStorage) {
        window.localStorage.setItem(key, 1)
      }
    },
    // エラーポップアップ閉じるボタン
    tapErrorClose() {
      this.trackEvent(FactoryTrack.createErrorClose())
      this.isError = false
    },
    // 最新データを取得
    tapRetryFetch() {
      this.trackEvent(FactoryTrack.createErrorRetry())
      this.$router.go()
    },
    // ユーザーデータ取得
    requestUserInfo() {
      try {
        const accTime = new DateFormatter().format(new Date())
        window.receivedToken = async payload => {
          const json = JSON.parse(payload)
          this.debugToken = json
          this.userType = json.user_type
          this.versionNo = json.version
          await this.fetchHomeData(json.app_token, accTime, json.user_id)
          window.receivedToken = null
          await this.getInviteeStampIfNeeded()
        }
        this.actionRequestToken({ apiType: '0', acc_time: accTime })
      } catch (e) {
        // ローカルコール用
        this.createErrorModal(
          ErrorCode.CODE_ERROR_TOKEN,
          ErrorMessage.MSG_ERROR_TOKEN
        )
        console.log(e)
        // this.fetchHomeData('', '', '')
      }
    },
    // Homeデータを取得
    async fetchHomeData(token, accTime, userId) {
      this.actionToggleLoading(true)
      try {
        await this.action_FetchInfo({
          token: token,
          accTime: accTime,
          userId: userId
        })
        setTimeout(() => {
          this.actionToggleLoading(false)
        }, 500)
        this.isLoaded = true
        this.__checkQuery()
        this.__checkAutoNavigate1() // URLクエリから詳細ページへ移動する
        // filter infolist with target_user_type to get normal infolist
        this.currentNewsList1 = this.newsList1.filter(
          data => data.target_user_type === '0'
        )
        this.currentNewsList2 = this.newsList2.filter(
          data => data.target_user_type === '0'
        )
      } catch (e) {
        this.actionToggleLoading(false)
        // console.error(e)
        if (e.code !== undefined || e.code !== '0000000') {
          this.createErrorModal(e.code, e.message)
          this.isLoaded = false
        }
      }
    },
    // URLのQueryパラメータを調べる
    __checkQuery() {
      this.condition = this.$route.query[this.idQueryString]
      if (!this.condition || this.condition === '') {
        window.localStorage.setItem(this.notificationKey, '')
      }
    },
    // URLクエリーから詳細ページに遷移
    __checkAutoNavigate1() {
      try {
        const news1 = this.currentNewsList1.find(
          news1 => news1.id === this.condition
        )
        const local = window.localStorage.getItem(this.notificationKey)
        if (news1) {
          if (local === news1.id) {
            window.localStorage.setItem(this.notificationKey, '') // リセットする、重複通知を有効にするため
            window.history.back() // 重複しているときは、さらに戻す、左肩の戻るボタンを消すため
            return
          }
          if (news1.url !== '') {
            this.navigateToRedirectDetail(this.condition, news1.url) // URLがあれば外部リンクへ
          } else {
            this.navigateToDetail(this.condition)
          }
          window.localStorage.setItem(this.notificationKey, news1.id) // Vueの詳細ページ移動時のみLocalStorageで管理する
        }
      } catch (e) {
        console.log(e)
      }
    },
    // Error Modalを作成する
    createErrorModal(code, message) {
      this.errorMessage = message
      this.errorTitle = 'エラー ' + code
      this.errorCode = code
      this.isError = true
    },
    __checkAndroid() {
      const ua = window.navigator.userAgent
      if (ua.indexOf('Android') >= 0) {
        this.isAndroid = true
      }
    },
    tapPremium() {
      this.actionNavigateTo('6') // 5:プレミアム画面
    },
    closeAlert: function() {
      this.verAlert = 0
    },
    async getInviteeStampIfNeeded() {
      const v61 = await this.actionVer6_1()
      const needed = v61 === 0
      if (!needed) {
        return
      }

      const accTime = new DateFormatter().format(new Date())
      const params = { apiType: '14', acc_time: accTime }

      try {
        window.receivedToken = async (payload, _apiType) => {
          window.receivedToken = null
          const json = JSON.parse(payload)
          if (!json.invitation_uuid) {
            return
          }

          try {
            const res = await APIClient.postAddInviteeStamp(
              json.app_token,
              accTime,
              json.user_id,
              json.invitation_uuid
            )
            if (
              res.status === 200 &&
              'data' in res &&
              'data' in res.data &&
              'num_stamps' in res.data.data &&
              'inviter_num_stamps' in res.data.data &&
              'inviter_expire_days' in res.data.data &&
              'invitee_expire_days' in res.data.data
            ) {
              this.numStamps = res.data.data.num_stamps
              this.inviterNumStamps = res.data.data.inviter_num_stamps
              this.inviterExpireDays = res.data.data.inviter_expire_days
              this.inviteeExpireDays = res.data.data.invitee_expire_days

              if (this.numStamps > 0) {
                this.isInvitationSuccess = true
              } else if (res.data.data.error) {
                this.isInvitationFailure = true
              }
            } else {
              this.isInvitationFailure = true
            }
            this.actionRemoveInvitationUUID()
          } catch (e) {
            this.isInvitationFailure = true
            console.error(e)
          }
        }
      } catch (e) {
        this.isInvitationFailure = true
        console.error(e)
      }

      this.actionRequestToken(params)
    },
    pickupMenuPriceForDisplay(price) {
      const numberPrice = parseInt(price)
      return isNaN(numberPrice) ? '' : numberPrice.toLocaleString()
    }
  }
}
</script>

<style scoped lang="scss">
.l_homepage {
  padding: 15px;
  .foryou {
    color: #66160E;
    font-weight: bold;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
  }
}

.l_homepage header {
  margin: 0px auto 15px;
  font-size: 15px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #66160E;
}

.l_contents {
  width: 100%;
  margin-top: 10px;
  padding-bottom: 20px;
}

/* popup背景 */
.l_popup__cover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
}

/* 背景表示のアニメーション */
.animation__background {
  animation: fadeIn 0.4s ease normal 0s none running;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
/* star */
.card-group {
  margin-left: auto;
  margin-right: auto;
  max-width: 640px;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-bottom: 20px;
}
.card-group > :nth-child(2n) {
  margin-left: 15px;
}
.card-group > :nth-child(n + 3) {
  margin-top: 20px;
}
.card {
  flex-basis: auto;
  width: calc((100% - 20px * 1) / 2);
  height: auto;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.card__imgframe_menu {
  position: relative;
  width: 100%;
  height: auto;
  background: #fff;
  box-sizing: border-box;
  margin: 0px;
}

.card__imgframe_menu img {
  width: 100%;
  height: auto;
}

.card__imgframe_menu::before {
  position: absolute;
  right: -30px;
  transform: scale(0.3);
}

.card__imgframe {
  width: 100%;
  height: auto;
  background: #fff;
  box-sizing: border-box;
  margin: 0px;
}

.c_img {
  max-width: 100%;
  vertical-align: bottom;
  width: 100%;
}
.card__imgframe img {
  width: 100%;
  height: auto;
}

.wrap {
  display: flex;
}

.card__textbox {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 90px;
  padding: 0px 8px;
  background: #fff;
  box-sizing: border-box;
}

.card__textbox > * + * {
  margin-top: 10px;
}
.card__titletext {
  padding-top: 5px;
  padding-bottom: 8px;
  text-align: left;
  line-height: 1.6;
  font-size: 13px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  color: rgba(51, 51, 51, 1);
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.card__overviewtext {
  display: flex;
  align-items: flex-end;
  margin-top: auto;
  padding-bottom: 6px;
}
.en {
  text-align: left;
  font-weight: bold;
  font-size: 13px;
  color: rgba(51, 51, 51, 1);
}
.price {
  line-height: 18px;
  font-style: normal;
  font-weight: bold;
  font-size: 21px;
  color: rgba(51, 51, 51, 1);
}
.price_all {
  text-align: left;
  font-style: normal;
  font-weight: normal;
  font-size: 9px;
  color: rgba(51, 51, 51, 1);
  white-space: nowrap;
}
.menu_title {
  white-space: nowrap;
  text-align: left;
  font-weight: bold;
  font-size: 18px;
  color: rgba(51, 51, 51, 1);
  padding-left: 5px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.card_title {
  padding-top: 3px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  color: rgba(51, 51, 51, 1);
}
.card_desc {
  line-height: 20px;
  text-align: left;
  font-size: 13px;
  font-weight: 300;
  line-height: 1.5;
  font-style: normal;
  color: rgba(51, 51, 51, 1);
}

</style>
